import op from 'object-path';
import { checkForMeasurementError, getCurrentBreakpoint } from '@/modules/utils';

const MEASUREMENTS = [
  { key: 'Foot Length', nameKey: 'foot_length' },
  { key: 'Foot Width', nameKey: 'foot_width' },
  { key: 'Foot Arch Height', nameKey: 'arch' },
  { key: 'Ball Circumference', nameKey: 'ball' },
  { key: 'Instep Circumference', nameKey: 'instep' },
  { key: 'Span Circumference', nameKey: 'span' },
  { key: 'Foot Finger Shape', nameKey: 'finger_shape' },
];

const feetMeasurements = {
  data: () => ({
    useInch: false,
    activeMeasurementIndex: -1,
    currentMeasurement: [],
    measurements: [],
    measurementFailed: false,
    feetToShow: [true, true],
    feetViewerProps: {
      cameraPositionX: -40,
      cameraPositionY: 20,
      maxPolarAngle: (Math.PI * 3.5) / 6,
      minPolarAngle: 0,
      fov: getCurrentBreakpoint() === 'xs' ? 25 : 40,
    },
  }),
  methods: {
    processMeasurements(data, skipError = false) {
      const { error, measurement } = data;
      const errors = checkForMeasurementError(error);
      if (errors.length > 0) {
        this.measurementFailed = true;
        if (!skipError) {
          throw new Error(`measurement failed, errors: ${errors.join(', ')}`);
        }
      }
      const selectedMeasurements = MEASUREMENTS.map(m => ({
        ...m,
        name: this.$t(`footscan.measurement__${m.nameKey}`),
        left: { ...op.get(measurement, `Left ${m.key}`, {}) },
        right: { ...op.get(measurement, `Right ${m.key}`, {}) },
      }));
      this.measurements = selectedMeasurements;
      this.$store.commit('user/SET_FEET_MEASUREMENTS', selectedMeasurements);
    },
    onUnitSwitch(useInch) {
      this.useInch = useInch;
    },
    setCurrentMeasurement(index, leftOrRight) {
      // deselect the current one
      if (this.activeMeasurementIndex === index && !leftOrRight) {
        this.currentMeasurement = [null, null];
        this.activeMeasurementIndex = -1;
        return;
      }

      const measurement = this.measurements[index];
      if (!measurement) return;

      this.activeMeasurementIndex = index;
      const { left, right } = measurement;
      if (leftOrRight) {
        const isLeft = leftOrRight === 'left';
        this.currentMeasurement = [isLeft ? left : null, isLeft ? null : right];
      } else {
        this.currentMeasurement = [left, right];
      }
    },
  },
  computed: {
    hasMeasurements() {
      return this.measurements.length > 0;
    },
  },
};

export default feetMeasurements;
